export default __webpack_public_path__ + "static/media/1-Cloudxier-MMSustainability-Mockup.00566929.jpg";